import OwnershipPostGamePage from "./OwnershipPostGamePage";

export default OwnershipPostGamePage;
